import { BaseApiService } from "../../base-api-service";
import { ApiVersions } from "../../../enums";
import { env } from "../../../environment";
import {
  Jackpot,
  JackpotRequest,
  JackpotResponse,
} from "../../../models/jackpot";
import { Ticket } from "../../../models";
import { JackpotDetails } from "../../../models/modal";

class JackpotController extends BaseApiService {
  public async getJackpot(params: JackpotRequest): Promise<JackpotResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/jackpot`;
    return await this.http.get(url, { params });
  }

  public async getJackpotDetails(
    id: number,
    level: number,
  ): Promise<JackpotDetails> {
    const url = `${this.url}/api/${ApiVersions.V1}/jackpot/${id}/${level}`;
    return await this.http.get(url);
  }

  public payJackpotTicket = async (
    barCode: number,
    ticketId: number,
  ): Promise<Ticket> => {
    const url = `${this.url}/api/${ApiVersions.V1}/tickets/${barCode}/pay-jackpot/${ticketId}`;
    return await this.http.put(url);
  };
}

export const jackpotController = new JackpotController({ url: env.httpUrl });
